export default class DtoPiezometryPicture {
    constructor(obj) {
        this.id = obj.id
        this.name = obj.name
        this.url = obj.url
    }
}